<template>
  <!-- The Superintresse panel's chunk could not be fetched: the bundle this
       tab was loaded from has been replaced by a deploy (ChunkLoadError), or
       the request failed or timed out. -->
  <div class="panel-error">
    <BaseIcon
      icon-file="alertcircle"
      :width="64"
      :height="64"
      class="panel-error-icon"
    />
    <h2 class="panel-error-title">
      {{ $t('super_interest_panel_error_title') }}
    </h2>
    <BaseButton class="grey smaller" @click="reload">
      {{ $t('proposition_load_error_retry') }}
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';
export default {
  name: 'SuperInterestPanelError',
  components: {
    BaseButton,
    BaseIcon
  },

  methods: {
    // Re-requesting the chunk cannot work when a deploy has removed it, so
    // the retry is a full load onto the current bundle.
    reload() {
      window.location.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
.panel-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 48px 24px 40px;
  color: var(--Text-Primary);

  @media ($desktop) {
    min-width: 480px;
  }
}

.panel-error-icon {
  margin-bottom: 24px;
}

.panel-error-title {
  font-family: 'OktaNeue';
  font-weight: 700;
  font-size: 20px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.01em;
  margin: 0 0 32px;
  text-wrap: pretty;
}
</style>
